module.exports = __webpack_public_path__ + "ck.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ck.svg
// module id = 492
// module chunks = 0